const scriptLoaded = new Set<string>()

export async function loadScript(path: string): Promise<void> {
  if (scriptLoaded.has(path)) {
    return Promise.resolve()
  }
  const script = document.createElement('script')
  script.async = true
  script.src = path
  return new Promise<void>((resolve, reject) => {
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Script load error: ${script.src}`))
    document.head.appendChild(script)
  })
}
